import React, { useState, useEffect } from "react";
import {
  BusinessProfileService,
  EventService,
  PaymentService,
} from "../../services";
import { AuthService } from "../../services";
import ReactPaginate from "react-paginate";
import { Button, Table } from "react-bootstrap";
import { formatDateENGB, handleConsoleError } from "../../utils/common-methods";
import { Link, useNavigate } from "react-router-dom";
import { routes } from "../../constants/routes";
import { injectModels } from "../../redux/injectModels";
import { EventStatus } from "../../constants/Enum";
import { SubscriptionService } from "../../services";
import Swal from "sweetalert2";
import { BusinessProfileModel } from "../../components/Model/businessProfileModel";
import { toast } from "react-toastify";

const EventList = (props) => {
  const loginUser = AuthService.getLoginUser();
  const [currentPage, setCurrentPage] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const navigate = useNavigate();
  const [activeSubscription, setActiveSubscription] = useState({
    id: "",
    name: "",
    commission: "",
    description: "",
    validity: "",
    startDate: "",
  });
  const [businessData, setBusinessData] = useState({ ...BusinessProfileModel });

  const rowsPerPage = 10; // Number of rows to display per page
  const offset = currentPage * rowsPerPage; // Calculate the offset based on current page
  const paginatedData = filteredData.slice(offset, offset + rowsPerPage);

  useEffect(() => {
    getData();
    getEventData();
  }, []);

  const getData = async () => {
    props.application.setLoading(true);

    try {
      const res = await SubscriptionService.getActiveSubscriptionById(
        loginUser?.id
      );
      if (res?.isSuccess && res?.data) {
        const sub = {
          id: res?.data?.subscriptionPlanId,
          name: res?.data?.subscriptionPlanName,
          commission: res?.data?.commissionPercentage,
          description: res?.data?.description,
          validity: "Unlimited",
          startDate: formatDateENGB(res?.data?.startDate),
        };
        setActiveSubscription(sub);
        const business = await BusinessProfileService.getBusinessProfileById(
          loginUser?.id
        );
        if (business.isSuccess) {
          setBusinessData(business?.data);
        }
        props.application.setLoading(false);
      } else {
        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
    }
  };

  const getEventData = async () => {
    try {
      if (loginUser) {
        props.application.setLoading(true);
        const res = await EventService.getEventsByUserId(loginUser?.id);
        if (res?.isSuccess && res?.data?.length > 0) {
          setFilteredData(res?.data);
        }
        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  const handleEdit = async (id, name, status) => {
    try {
      navigate(routes.ACCOUNT_EDIT_EVENT.replace(":eventId", id)); //
    } catch (error) {}
  };

  const calculateSNo = (index) => {
    return offset + index + 1;
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };
  const handleView = async (id, name, status) => {
    try {
      navigate(routes.EVENT_DETAILS.replace(":eventId", id));
    } catch (error) {}
  };

  const getEventProfiles = async (eventId) => {
    const res = await EventService.GetApprovedTradersByEventId(eventId);
    if (res?.isSuccess && res?.data) {
      return res?.data;
    }
    return null;
  };

  const renderPagination = () => {
    const pageCount = Math.ceil(filteredData.length / rowsPerPage);
    if (pageCount > 1) {
      return (
        <ReactPaginate
          previousLabel="previous"
          nextLabel="next"
          breakClassName={"page-item"}
          breakLinkClassName={"page-link"}
          containerClassName={"pagination"}
          pageClassName={"page-item"}
          pageLinkClassName={"page-link"}
          previousClassName={"page-item"}
          previousLinkClassName={"page-link"}
          nextClassName={"page-item"}
          nextLinkClassName={"page-link"}
          activeClassName={"active"}
          pageCount={pageCount}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          onPageChange={handlePageChange}
          forcePage={currentPage}
          breakLabel="..."
          disableInitialCallback={false}
        />
      );
    }
    return null;
  };

  const isEmptyGuid = (guid) => {
    return guid === "00000000-0000-0000-0000-000000000000";
  };

  const handleCreateEvent = async (e) => {
    try {
      e.preventDefault();
      if (activeSubscription?.name?.length < 2) {
        Swal.fire({
          title: "Subscription",
          text: "Please add subscription plan to create event.",
          icon: "info",
          buttonsStyling: false,
        });
        navigate(routes.ACCOUNT_ACTIVESUBSCRIPTIONP);
        return;
      }
      if (businessData?.id?.length < 2 || isEmptyGuid(businessData?.id)) {
        Swal.fire({
          title: "Business Profile",
          text: "Please add business profile to create event.",
          icon: "info",
          buttonsStyling: false,
        });
        navigate(routes.ACCOUNT_BUSINESSINFO);
        return;
      }
      props.application.setLoading(true);
      const res = await PaymentService.getConnectedAccountByUserId(
        loginUser?.id
      );
      if (res?.isSuccess && res?.data) {
        const linkAccountData = res?.data;
        if (
          !linkAccountData ||
          !linkAccountData.payoutsEnabled ||
          !linkAccountData.chargesEnabled
        ) {
          props.application.setLoading(false);
          navigate(routes.ACCOUNT_MANAGE_PAYMENT);
        } else {
          props.application.setLoading(false);
          navigate(routes.ACCOUNT_CREATE_EVENT);
        }
      } else {
        props.application.setLoading(false);
        navigate(routes.ACCOUNT_MANAGE_PAYMENT);
      }
      props.application.setLoading(false);
    } catch (error) {
      props.application.setLoading(false);
      navigate(routes.ACCOUNT_MANAGE_PAYMENT);
    }
  };

  return (
    <React.Fragment>
      <section className="edit-form-table">
        <div className="container mt-3">
          <div className="verifier-buttton">
            <Button onClick={handleCreateEvent}>Create New Event</Button>{" "}
          </div>
          <div className="table-responsive">
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Event Name</th>
                  <th>Event Category</th>
                  <th>Event Status</th>
                  <th>Created On</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {paginatedData && paginatedData.length > 0 ? (
                  <React.Fragment>
                    {paginatedData.map((item, idx) => {
                      return (
                        <tr key={idx}>
                          <td>{calculateSNo(idx)}</td>
                          <td>{item?.eventName}</td>

                          <td>{item?.eventCategoryTypeName}</td>
                          <td>{item?.eventStatusName}</td>
                          <td>{formatDateENGB(item?.createdOn)}</td>
                          <td>
                            <div className="delete-create col">
                              {(item?.eventStatusId === EventStatus.Draft ||
                                item?.eventStatusId ===
                                  EventStatus.Awaiting) && (
                                <Link
                                  title="Edit Event"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleEdit(
                                      item?.id,
                                      item?.eventName,
                                      item?.eventStatusId
                                    );
                                  }}
                                  style={{ marginRight: "10px" }}
                                >
                                  <i className="ri-pencil-line"></i>
                                </Link>
                              )}
                              <Link
                                title="View Event"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleView(
                                    item?.id,
                                    item?.eventName,
                                    item?.eventStatusId
                                  );
                                }}
                                style={{ marginRight: "10px" }}
                              >
                                <i className="fa fa-eye"></i>
                              </Link>
                              {item?.eventStatusId !== EventStatus.Draft &&
                                item?.eventStatusId !== EventStatus.Canceled &&
                                item?.eventStatusId !== EventStatus.Awaiting &&
                                item?.eventStatusId !== EventStatus.Rejected &&
                                item?.isEventMessageGroup && (
                                  <Link
                                    title="Manage Group Message"
                                    onClick={async (e) => {
                                      e.preventDefault();
                                      const profileData = await getEventProfiles(
                                        item.id
                                      );
                                      if (
                                        profileData &&
                                        profileData.approvedTraders?.length > 0
                                      ) {
                                        navigate(routes.MESSAGE_INBOX, {
                                          state: {
                                            toUser: {
                                              eventId: profileData?.eventId,
                                              organizerBusinessName:
                                                profileData?.organizerBusinessName,
                                              eventName: profileData?.eventName,
                                              eventAvatar:
                                                profileData?.eventAvatar,
                                              isGroup: true,
                                              users:
                                                profileData?.approvedTraders,
                                            },
                                            isRedirect: true,
                                          },
                                        });
                                      }
                                    }}
                                  >
                                    <i className="fa-solid fa-comment-dots"></i>
                                  </Link>
                                )}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </React.Fragment>
                ) : (
                  <tr>
                    <td colSpan="10 mt-2">No results found</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>

          <div className="table-footer">
            <p className="mb-3">
              <strong>Total Count: {filteredData.length}</strong>
            </p>
            {filteredData.length === 0 ? "" : renderPagination()}
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default injectModels(["application"])(EventList);
